__turbopack_context__.v({
  "actions": "PdpActions-module__sD1moW__actions",
  "actions-wrapper": "PdpActions-module__sD1moW__actions-wrapper",
  "blok-big-title": "PdpActions-module__sD1moW__blok-big-title",
  "blok-subtitle": "PdpActions-module__sD1moW__blok-subtitle",
  "blok-title": "PdpActions-module__sD1moW__blok-title",
  "dialog-content": "PdpActions-module__sD1moW__dialog-content",
  "downloadFreeRecipe": "PdpActions-module__sD1moW__downloadFreeRecipe",
  "label": "PdpActions-module__sD1moW__label",
  "modal-actions": "PdpActions-module__sD1moW__modal-actions",
});
